'use strict';

export default class EventsDetails {
  constructor() {
    let minutes = parseInt($('body.page-node-type-events div.time span.duration').html());

    var d = Math.floor(minutes / (60 * 24));
    var h = Math.floor(minutes % (60 * 24) / 60);
    var m = Math.floor(minutes % 60 / 60);

    var dDisplay = d > 0 ? d + (d == 1 ? " day " : " days ") : "";
    var hDisplay = h > 0 ? h + (h == 1 ? " hour " : " hours ") : "";
    var mDisplay = m > 0 ? m + (m == 1 ? " minute " : " minutes ") : "";

    
    setTimeout(function(){ 
      $('body.page-node-type-events div.time span.duration').html(" " + dDisplay + hDisplay + mDisplay)
     }, 3000);

  }
}


